export function replacePlaceholders(template: string, data: any) {
  let html = template || "";

  const map: Record<string, string> = {
    "#STUDENTNAME#": data.studentName || "",
    "{{STUDENTNAME}}": data.studentName || "",
    "#SCHOLARNO#": data.scholarNo || "",
    "{{SCHOLARNO}}": data.scholarNo || "",
    "#SCHOLARNUMBER#": data.scholarNo || "",
    "{{SCHOLARNUMBER}}": data.scholarNo || "",
    "#CLASS#": data.className || "",
    "{{CLASS}}": data.className || "",
    "#SECTION#": data.sectionName || "",
    "{{SECTION}}": data.sectionName || "",
    "#DOB#": data.dob ? new Date(data.dob).toLocaleDateString() : "",
    "{{DOB}}": data.dob ? new Date(data.dob).toLocaleDateString() : "",
    "#BLOODGROUP#": data.bloodGroup || "",
    "{{BLOODGROUP}}": data.bloodGroup || "",
    "#VALIDUPTO#": data.validUpto ? new Date(data.validUpto).toLocaleDateString() : "",
    "{{VALIDUPTO}}": data.validUpto ? new Date(data.validUpto).toLocaleDateString() : "",
  };

  for (const [k, v] of Object.entries(map)) {
    html = html.replace(new RegExp(k, "g"), v);
  }

  // Handle Photo
  const photoUrl = data.photoUrl || "";
  const photoTag = photoUrl 
    ? `<img src="${photoUrl}" class="id-card-photo" alt="Student Photo" />` 
    : `<div class="id-card-photo-placeholder">No Photo</div>`;

  // Replace src in existing img tags
  if (photoUrl) {
    html = html.replace(
      /(<img[^>]*\bsrc\s*=\s*["']\s*)(#PHOTO#|{{PHOTO}})(["'][^>]*>)/gi,
      (_m, p1, _ph, p3) => `${p1}${photoUrl}${p3}`
    );
  }

  // Replace standalone placeholders
  html = html.replace(/(#PHOTO#|{{PHOTO}})/g, photoTag);

  return html;
}
